import React from 'react';

import TopProducts from 'ggApp/shared/components/widgets/topProductsWidget';
import HandPickedProducts from 'ggApp/shared/components/widgets/handPickedProductWidget';
import { WidgetProductType } from 'ggApp/utils/product/types';

import { ProductCarousel, CategoryWidget } from './styles';

export enum ProductWidgetStyles {
    topProducts = 'topProducts',
    productCarousel = 'productCarousel',
    category = 'category',
    handpicked = 'handpicked',
}

interface ProductWidgetProps {
    className: string;
    widgetData: {
        style: ProductWidgetStyles;
        products: WidgetProductType[];
        title?: string;
        cta?: {
            url: string;
            label: string;
        };
        category?: {
            iconUrl: string;
            name: string;
        };
    };
    productImpressionCallbacks: (firstProductIndex: number) => void;
    widgetListProducts: WidgetProductType[];
    testId?: string;
}

export const ProductWidget = ({
    className,
    widgetData,
    productImpressionCallbacks,
    widgetListProducts,
    testId,
}: ProductWidgetProps): JSX.Element | null => {
    if (!widgetData?.products?.length || !widgetListProducts?.length) {
        return null;
    }

    const firstProductIndex = widgetListProducts.findIndex(
        (product: WidgetProductType) => product.id === widgetData.products[0].id,
    );

    switch (widgetData.style) {
        case ProductWidgetStyles.topProducts:
            return (
                <TopProducts
                    className={className}
                    products={widgetData.products}
                    productImpressionCallbacks={productImpressionCallbacks(firstProductIndex)}
                    testId={testId}
                />
            );
        case ProductWidgetStyles.productCarousel:
            return (
                <ProductCarousel
                    className={className}
                    products={widgetData.products}
                    title={widgetData.title}
                    cta={widgetData.cta}
                    productImpressionCallbacks={productImpressionCallbacks(firstProductIndex)}
                    firstIndexProduct={firstProductIndex}
                    testId={testId}
                />
            );
        case ProductWidgetStyles.category:
            return (
                <CategoryWidget
                    className={className}
                    products={widgetData.products}
                    category={widgetData.category}
                    widgetType="horizontal"
                    cta={widgetData.cta}
                    productImpressionCallbacks={productImpressionCallbacks(firstProductIndex)}
                    firstIndexProduct={firstProductIndex}
                    testId={testId}
                />
            );
        case ProductWidgetStyles.handpicked:
            return (
                <HandPickedProducts
                    className={className}
                    products={widgetData.products}
                    productImpressionCallbacks={productImpressionCallbacks(firstProductIndex)}
                    firstIndexProduct={firstProductIndex}
                    testId={testId}
                />
            );
        default:
            return null;
    }
};

export default ProductWidget;
